import ObjectJson from './object.json.js'

export default class ObjectJsonArray extends ObjectJson {

}